import { render, staticRenderFns } from "./CodeUsage.vue?vue&type=template&id=2450f172&"
import script from "./CodeUsage.vue?vue&type=script&lang=js&"
export * from "./CodeUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports